import ApiError from 'utils/api/errors/ApiError';


class ApiNetworkError extends ApiError {
  constructor (props) {
    super(props);
    this.name = 'ApiNetworkError';
  }
}

export default ApiNetworkError;
